module.exports = __webpack_public_path__ + "static/img/people2.1316efd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/life/people2.jpg
// module id = ruof
// module chunks = 1